<template>
  <div class="ws-group-state">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>